import { ExtendedLesson, UNIT_SOURCE_ID } from "../../../model";
import { MATERIAL_QUESTIONS, UNIT_QUESTIONS } from "./model";

export const getQuestionsByType = (lesson: ExtendedLesson) => {

  const map = lesson.elementSource === UNIT_SOURCE_ID ?
    UNIT_QUESTIONS :
    MATERIAL_QUESTIONS;

  const questionKeys = Object.keys(map);

  return {
    questions: map,
    questionKeys,
  };
};
